'use client';

import { Drawer } from '@ui/components/common/drawer';

import { ProfileShareContent, ProfileShareContentProps } from './ProfileShareContent';

export interface ProfileShareDrawerProps extends Omit<ProfileShareContentProps, 'showHeader'> {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

export function ProfileShareDrawer({
  isOpen,
  onClose,
  profileUrl,
  userName,
  logoUrl,
  roleText,
  companyName,
  translations,
  onSaveAndDownload,
  title = 'Share Profile'
}: ProfileShareDrawerProps) {
  return (
    <Drawer
      trigger={<div style={{ display: 'none' }} />}
      side="bottom"
      open={isOpen}
      onOpenChange={onClose}
      title={title}
      className="px-5 py-0 rounded-t-lg"
    >
      <ProfileShareContent
        profileUrl={profileUrl}
        userName={userName}
        logoUrl={logoUrl}
        roleText={roleText}
        companyName={companyName}
        isMobile={true}
        translations={translations}
        onSaveAndDownload={onSaveAndDownload}
        showHeader={false}
      />
    </Drawer>
  );
}
